import * as React from 'react';
import { Plus } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { FilterDef } from './types';

interface AddFilterPopoverProps {
  /** Filters that are not currently shown and can be added. */
  available: FilterDef[];
  onPick: (def: FilterDef) => void;
}

/** The Linear-style "+ Filter" menu listing filters that aren't active yet. */
const AddFilterPopover: React.FC<AddFilterPopoverProps> = ({ available, onPick }) => {
  const [open, setOpen] = React.useState(false);

  if (available.length === 0) return null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="h-9 gap-1.5 border-dashed">
          <Plus className="h-3.5 w-3.5" />
          Filter
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[200px] p-1" align="start">
        {available.map((def) => (
          <button
            key={def.id}
            type="button"
            className="flex items-center gap-2 w-full px-2 py-1.5 text-sm rounded-md hover:bg-accent text-left"
            onClick={() => {
              setOpen(false);
              onPick(def);
            }}
          >
            {def.icon}
            {def.label}
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
};

export default AddFilterPopover;
